<template>
  <div>
    <b-nav-item-dropdown right no-caret>
      <template slot="button-content">
        <img :src="$parent.$parent.getUrlAvatarImage('profiles/anonymous.png')" class="img-avatar" alt="Usuario anonimo" v-if="$parent.$parent.authenticated === false">
        <img :src="$parent.$parent.getUrlAvatarImage($parent.$parent.datos_usuario_autenticado.imagen_genero)" class="img-avatar" v-else-if="$parent.$parent.authenticated === true" :alt="$parent.$parent.datos_usuario_autenticado.primer_nombre + ' ' + $parent.$parent.datos_usuario_autenticado.primer_apellido">
      </template>
      <b-dropdown-item v-if="$parent.$parent.authenticated === false" @click="abrirModalInicioSesion()"><i class="fa fa-shield"></i> Iniciar Sesión</b-dropdown-item>
      <b-dropdown-item v-if="$parent.$parent.authenticated === false" @click="gestionRegistroUsuario()"><i class="fa fa-address-book-o fa-lg"></i> Registro</b-dropdown-item>
      <b-dropdown-item v-if="$parent.$parent.authenticated === true" @click="perfilUsuario()"><i class="fa fa-lock"></i> Mi perfil</b-dropdown-item>
      <b-dropdown-item v-if="$parent.$parent.authenticated === true" @click="cerrarSesion()"><i class="fa fa-lock"></i> Cerrar sesión</b-dropdown-item>
    </b-nav-item-dropdown>

    <b-modal ref="modalInicioSesion" title="Iniciar sesión" no-close-on-backdrop no-close-on-esc centered hide-footer hide-header-close class="modal-info">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <h1>Acceso</h1>
            <div class="alert alert-danger" v-if="error">
              <p>Hubo un error, no se pudo iniciar sesión con esas credenciales.</p>
            </div>

            <form autocomplete="off" v-on:submit.prevent="iniciarSesion" v-if="procesando == false">
              <p class="text-muted">Ingrese a su cuenta</p>
              <div class="input-group mb-3">
                <span class="input-group-addon"><i class="icon-user"></i></span>
                <input type="text" class="form-control" placeholder="Correo electrónico" name="email" v-model="email" :disabled="procesando" required>
              </div>
              <div class="input-group mb-4">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
                <input type="password" class="form-control" placeholder="Contraseña" name="password" v-model="password" :disabled="procesando" required>
              </div>
              <b-row>
                <b-col cols="12">
                  <a class="text-primary" style="cursor:pointer" @click="gestionRecuperarClave()">¿Recuperar clave?</a>
                  <br />
                  <br />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <button variant="primary" type="submit" class="btn btn-primary px-4" :disabled="procesando">Ingresar</button>
                </b-col>
                <b-col cols="4" class="text-right">
                  <button variant="success" type="button" class="btn btn-success px-4" @click="gestionRegistroUsuario()" :disabled="procesando">Registro</button>
                </b-col>
                <b-col cols="4" class="text-right">
                  <button variant="secondary" type="button" class="btn btn-secondary px-4" @click="cerrarModalInicioSesion()" :disabled="procesando">Cerrar</button>
                </b-col>
              </b-row>
            </form>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">

                </b-progress-bar>
              </b-progress>
            </b-alert>

          </b-card-body>
        </b-card>
      </b-card-group>
    </b-modal>

    <b-modal ref="modalCerrarSesion" title="Cerrando sesión" no-close-on-backdrop no-close-on-esc centered hide-footer hide-header-close class="modal-warning">
      Cerrando la sesión del usuario ({{$parent.$parent.datos_usuario_autenticado.primer_nombre}}
      {{$parent.$parent.datos_usuario_autenticado.primer_apellido}}).
      Por favor espere.
    </b-modal>

  </div>
</template>
<script>
  import Vue from 'vue'
  import router from '@/router/index.js'
  import auth from '@/js/auth.js'
  import usuario from '@/js/usuario.js'
  import session from '@/js/session.js'
  import { EventBus } from '@/js/EventBus.js'

  export default {
    name: 'header-dropdown',
    created () {
    },
    mounted () {
      this.procesando = false
    },
    data () {
      return {
        email: null,
        password: null,
        error: false,
        procesando: true,
        email_usuario_autenticado: ''
      }
    },
    methods: {
      abrirModalInicioSesion () {
        this.$refs.modalInicioSesion.show()
      },
      cerrarModalInicioSesion () {
        this.$refs.modalInicioSesion.hide()
      },
      gestionRegistroUsuario () {
        this.$refs.modalInicioSesion.hide()

        router.push({
          name: 'usuario-registro'
        })
      },
      gestionRecuperarClave () {
        this.$refs.modalInicioSesion.hide()

        router.push({
          name: 'usuario-recuperar-clave'
        })
      },
      perfilUsuario () {
        router.push({
          name: 'usuario-perfil'
        })
      },
      iniciarSesion () {
        auth.email = this.email
        auth.password = this.password
        this.procesando = true
        this.error = false

        auth.signin().then(response => {
          if (response.status === 'success') {
            sessionStorage.setItem('token', JSON.stringify(response.data))

            // Consultar datos del usuario autenticado
            usuario.getUsuarioAutenticado().then(response => {
              if (response.status === 'success') {
                this.error = false
                this.procesando = false

                let datosUsuarioAutenticado = response.data
                datosUsuarioAutenticado.imagen_genero = datosUsuarioAutenticado.imagen_genero

                sessionStorage.setItem('datos_usuario_autenticado', JSON.stringify(datosUsuarioAutenticado))
                sessionStorage.setItem('seccion', 'Home')

                this.$parent.$parent.authenticated = true
                this.$parent.$parent.datos_usuario_autenticado = response.data
                this.$parent.$parent.ruta_back = Vue.http.options.root
                this.$refs.modalInicioSesion.hide()

                EventBus.$emit('authenticationEvent', {})

                session.loginChat()

                router.push({
                  name: 'home'
                })
              } else {
                // console.log(response)
                this.error = true
                this.procesando = false
              }
            })
          } else {
            // console.log(response)
            this.error = true
            this.procesando = false
          }
        })
      },
      cerrarSesion () {
        this.$refs.modalCerrarSesion.show()
        auth.signout().then(response => {
          this.$parent.$parent.authenticated = false
          this.$parent.$parent.datos_usuario_autenticado = {}
          this.$refs.modalCerrarSesion.hide()

          sessionStorage.clear()
          session.logoutChat()

          router.push({
            name: 'home'
          })
          EventBus.$emit('authenticationEvent', {})
        })
      }
    }
  }
</script>
<style lang="css">
  /* #jsxc_roster p,
  #jsxc_menu
  {
    visibility: hidden
  } */
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdown.vue